export default "__VITE_ASSET__BybEjuwc__"